export default {
  methods: {
    phoneValidate() {
      const pattern =
        /^((\+7)[ -] ?)?((\(\d{3}\))|(\d{3}))?([ -])?(\d{3}[- ]?\d{2}[- ]?\d{2})$/
      if (
        this.inputValue &&
        this.inputValue !== '+7 (' &&
        !pattern.test(String(this.inputValue).trim().toLowerCase())
      ) {
        this.message = 'Номер телефона должен состоять из 10 цифр!'
        this.status = 'error'
        return false
      } else {
        this.message = ''
        this.status = 'done'
        this.isEmptyValue = true
        return true
      }
    },
  },
}
